import React from "react";
import './style.css'
const Empty = () => {
    return (<div className='empty-cart'>Your Shopping Cart is empty! Go shop to fill up the Cart!

    </div>)
}
export default Empty;